import { FC, useMemo } from "react"
import clsx from "clsx"

function normalizeHex(input: string) {
  let v = input.trim()
  if (!v) return "#"
  if (!v.startsWith("#")) v = "#" + v
  return v
}

function isValidHex(v: string) {
  return /^#[0-9a-fA-F]{6}$/.test(v)
}

export const ColorPickerField: FC<{
  label?: string
  value: string
  onChange: (hex: string) => void
}> = ({ label = "Color", value, onChange }) => {
  const normalized = useMemo(() => normalizeHex(value), [value])

  const isIncomplete = normalized === "#"
  const isValid = isValidHex(normalized)
  const showError = !isIncomplete && normalized.length > 1 && !isValid

  const safeColor = isValid ? normalized : "#64748B"

  return (
    <div>
      <div className="text-sm opacity-80 mb-1">{label}</div>

      <div className={clsx("flex items-center gap-2 input input-bordered w-full", { "border-error": showError })}>
        <input
          type="color"
          className="h-8 w-10 cursor-pointer bg-transparent border-none p-0"
          value={safeColor}
          onChange={(e) => onChange(e.target.value)}
          title="Pick a color"
        />

        <input
          className="w-full bg-transparent outline-none"
          value={normalized}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#64748B"
          inputMode="text"
        />
      </div>

      {showError && <div className="text-xs text-error mt-1">Invalid HEX. Use format #RRGGBB</div>}
    </div>
  )
}
